import { $, component$, type PropsOf } from "@builder.io/qwik";
import { cn } from "~/lib/cn";

type InputProps = PropsOf<"input"> & {
  error?: unknown;
};

export const Input = component$<InputProps>(
  ({
    type,
    ["bind:value"]: valueSig,
    value,
    onInput$,
    class: className,
    ...props
  }) => {
    return (
      <input
        type={type}
        class={cn(
          "input flex h-10",
          {
            "border-red-700 focus:border-red-700 focus:ring-red-200":
              props.error,
          },
          className,
        )}
        value={valueSig ? valueSig.value : value}
        onInput$={
          valueSig ? $((_, el) => (valueSig.value = el.value)) : onInput$
        }
        {...props}
      />
    );
  },
);
